import React from "react";
// import Modal from "../utils/Modal";
function HeroHomeCollage() {
  // const [videoModalOpen, setVideoModalOpen] = useState(false);
  return (
    <div>
      <div
        className="relative flex justify-center mb-8 select-none"
        data-aos="zoom-y-out"
        data-aos-delay="450"
      >
        <div className="flex flex-col justify-center relative w-full max-w-[800px]">
          <img
            className="mx-auto w-full"
            src={
              require("../images/heros-and-graphics/koi-collage/hero-koi-collage-bg.png")
                .default
            }
            alt="Hero Background"
          />
          {/* <div
            className="absolute top-[10%] sm:top-[25%] right-[4%] w-[35%] h-[300px] animate-gentleUpDown2 bg-center bg-no-repeat bg-contain"
            style={{
              backgroundImage: `url(${
                require("../images/heros-and-graphics/koi-collage/hero-koi-collage-references-zoom.png")
                  .default
              })`,
            }}
          ></div> */}
          {/* <div
            className="absolute top-[12%] sm:top-[22%] left-[3%] w-[75%] h-[350px] animate-gentleUpDown3 bg-center bg-no-repeat bg-contain"
            style={{
              backgroundImage: `url(${
                require("../images/heros-and-graphics/koi-collage/hero-koi-collage-value-chains-package-delivery.png")
                  .default
              })`,
            }}
          ></div> */}
          {/* <div
            className="absolute top-[10%] -left-[3%] w-[75%] h-[150px] animate-gentleUpDown3 bg-center bg-no-repeat bg-contain"
            style={{
              backgroundImage: `url(${
                require("../images/heros-and-graphics/koi-collage/hero-koi-collage-condition-monitoring-chain.png")
                  .default
              })`,
            }}
          ></div>
          <div
            className="absolute bottom-[14%] sm:bottom-[8%] right-[2%] w-[50%] h-[200px] animate-gentleUpDown1 bg-center bg-no-repeat bg-contain"
            style={{
              backgroundImage: `url(${
                require("../images/heros-and-graphics/koi-collage/hero-koi-collage-graphs.png")
                  .default
              })`,
            }}
          ></div> */}
          <div
            className="absolute bottom-0 left-0 w-full h-full bg-center bg-no-repeat bg-contain animate-gentleUpDown2"
            style={{
              backgroundImage: `url(${
                require("../images/heros-and-graphics/koi-collage/hero-koi-computers-2.png")
                  .default
              })`,
            }}
          ></div>
          <div
            className="absolute bottom-0 left-0 w-full h-full bg-center bg-no-repeat bg-contain"
            style={{
              backgroundImage: `url(${
                require("../images/heros-and-graphics/koi-collage/hero-koi-computers-1.png")
                  .default
              })`,
            }}
          ></div>
          <a
            className="group absolute top-full right-[10%] flex items-center transform -translate-y-1/2 bg-rhoLime-700 hover:bg-rhoLime-400 rounded-full font-semibold group p-4 shadow-lg focus:outline-none"
            href="https://koi.eco"
            target="_blank"
            rel="noreferrer"
          >
            Explore Koi &nbsp;
            <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-2">
              <i className="fa-solid fa-arrow-right"></i>
            </span>
          </a>
        </div>
      </div>

      {/* Modal */}
      {/* <Modal
              id="modal"
              ariaLabel="modal-headline"
              show={videoModalOpen}
              handleClose={() => setVideoModalOpen(false)}
            >
              <div className="relative pb-9/16">
                <iframe
                  className="absolute w-full h-full"
                  src="https://player.vimeo.com/video/174002812"
                  title="Video"
                  allowFullScreen
                ></iframe>
              </div>
            </Modal> */}
    </div>
  );
}

export default HeroHomeCollage;
